import GetStarted from "../../assets/GetStarted.svg";
import { linksConstants } from "../../../../constants/linksConstants";
import { LinkButton } from "../../../views/components/LinkButton";
import clsx from "clsx";
import Image from "next/image";

export const GetStartedNew = ({ className }) => {
  return (
    <section className={clsx("home_get_started_new-background", className)}>
      <div className="home_get_started_new">
        <section className="section-layout">
          <div className="home_get_started_new-banner">
            <div>
              <h2>Get started with one of Demyst's experts</h2>
              <p className="home_get_started_new-text">
                Request a demo to see how the Demyst Platform transforms the world’s leading
                businesses.
              </p>
              <LinkButton autoWidth variant="inverted" href={linksConstants.REQUEST_DEMO}>
                Request Demo
              </LinkButton>
            </div>
            <Image src={GetStarted.src} alt="" height="353" width="482" />
          </div>
        </section>
      </div>
    </section>
  );
};
